import NumberAboveOrEqualsFeatureSwitchCheck from "./NumberAboveOrEqualsFeatureSwitchCheck";
import { UserType } from "types/Users";


export class UserSignedUpAfter extends NumberAboveOrEqualsFeatureSwitchCheck {

  protected getUserProperty(user: UserType | null | undefined): number | undefined {
    if (!user) {
      return undefined;
    }
    return Date.parse(user.signedUpAt || "") || undefined;
  }

  protected parseFeatureValue(featureSwitchValue: string | undefined): number | undefined {
    return Date.parse(featureSwitchValue || "") || undefined;
  }

}
